import { render } from "./DisplayTaskTemplate.vue?vue&type=template&id=4023a357"
import script from "./DisplayTaskTemplate.vue?vue&type=script&lang=js"
export * from "./DisplayTaskTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__